// extracted by mini-css-extract-plugin
export var chatHtmlText = "_oh-2";
export var chatLink = "_oh-0";
export var chatText = "_oh-1";